import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PacienteService } from 'app/services/paciente.service';
import { MedicoService } from 'app/services/medico.service';
import { UsuarioPanelService } from 'app/services/usuario-panel.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass']
})
export class FooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  tipoUsuario: string | null = null;
  mostrarTerminos: boolean = false;

  constructor(
    private router: Router,
    private pacienteService: PacienteService,
    private medicoService: MedicoService,
    private usuarioPanelService: UsuarioPanelService
  ) { }

  ngOnInit(): void {
    this.detectarTipoUsuarioYVerificarTyC();
  }

  detectarTipoUsuarioYVerificarTyC(): void {
    const url = this.router.url;

    if (url.includes('paciente')) {
      this.tipoUsuario = 'seccion-paciente';
      this.verificarTyCPaciente();
    } else if (url.includes('medico')) {
      this.tipoUsuario = 'seccion-medico';
      this.verificarTyCMedico();
    } else if (url.includes('panel')) {
      this.tipoUsuario = 'seccion-panel';
      this.verificarTyCPanel();
    } else {
      this.mostrarTerminos = false;
    }
  }

  verificarTyCPaciente(): void {
    this.pacienteService.pacienteLogeado().subscribe({
      next: (data) => {
        // Mostrar el enlace solo si el paciente ya aceptó TyC
        this.mostrarTerminos = data.paciente && data.paciente.tc_aceptado !== null && data.paciente.tc_aceptado !== undefined;
      },
      error: () => {
        this.mostrarTerminos = false;
      }
    });
  }

  verificarTyCMedico(): void {
    this.medicoService.medicoLogeado().subscribe({
      next: (data) => {
        // Mostrar el enlace solo si el médico ya aceptó TyC
        this.mostrarTerminos = data.medico && data.medico.tc_aceptado !== null && data.medico.tc_aceptado !== undefined;
      },
      error: () => {
        this.mostrarTerminos = false;
      }
    });
  }

  verificarTyCPanel(): void {
    this.usuarioPanelService.profileUser().subscribe({
      next: (data) => {
        // Mostrar el enlace solo si el usuario panel ya aceptó TyC
        this.mostrarTerminos = data && data.tc_aceptado !== null && data.tc_aceptado !== undefined;
      },
      error: () => {
        this.mostrarTerminos = false;
      }
    });
  }

}
